import React from 'react';

export const SideBarData = [
  {
    title: 'Chapter 1',
    path: '/',
    cName: 'nav-text'
  },
  {
    title: 'Chapter 2',
    path: '/reports',
    cName: 'nav-text'
  },
  {
    title: 'Chapter 3',
    path: '/products',
    cName: 'nav-text'
  },
  {
    title: 'Chapter 4',
    path: '/team',
    cName: 'nav-text'
  },
  {
    title: 'Chapter 5',
    path: '/messages',
    cName: 'nav-text'
  },
  {
    title: 'Support',
    path: '/support',
    cName: 'nav-text'
  }
];